export default{
	standardTiles: [
		{ name: '01', openings: [0, 1], path: 'M200 0V80C200 150 250 200 320 200H400', pathType: 'curve' },
		{ name: '02', openings: [0, 2], path: 'M200 0L200 400', pathType: 'straight' },
		{ name: '03', openings: [0, 3], path: 'M200 0V80C200 150 150 200 80 200H0', pathType: 'curve' },
		{ name: '12', openings: [1, 2], path: 'M400 200H320C250 200 200 250 200 320V400', pathType: 'curve' },
		{ name: '13', openings: [1, 3], path: 'M400 200L0 200', pathType: 'straight' },
		{ name: '23', openings: [2, 3], path: 'M200 400 L200 320C200 250 150 200 80 200L0 200', pathType: 'curve' },
		{ name: '0213', openings: [0, 2, 1, 3], path: 'M200 0L200 400', path2: 'M400 200 L0 200', pathType: 'cross' },
	],
	startTiles: [
		{ name: '0', openings: [0,0], path: "M200 200 L200 0", pathType: 'start' },
		{ name: '1', openings: [1,1], path: "M200 200 L400 200", pathType: 'start' },
		{ name: '2', openings: [2,2], path: "M200 200 L200 400", pathType: 'start' },
		{ name: '3', openings: [3,3], path: "M200 200 L0 200", pathType: 'start' }
	],
	endTiles: [
		{ name: '0', openings: [0,0], path: "M200 0 L200 200", pathType: 'end' },
		{ name: '1', openings: [1,1], path: "M400 200 L200 200", pathType: 'end' },
		{ name: '2', openings: [2,2], path: "M200 400 L200 200", pathType: 'end' },
		{ name: '3', openings: [3,3], path: "M0 200 L200 200", pathType: 'end' }
	]
}

